__turbopack_context__.v({
  "richText": "index-module-scss-module___nWB9W__richText",
});
